import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKredietcheck = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M35 12H5v16h30z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M18.5 21.66h-4.69v-1h4.69zM18.5 19.41h-4.69v-1h4.69z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M19.944 14.5a5.5 5.5 0 0 1 2.739.693l-.486.874a4.5 4.5 0 1 0 0 7.866l.486.874a5.5 5.5 0 1 1-2.74-10.307"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M12.88 26.94a9.88 9.88 0 1 1 14 0 9.89 9.89 0 0 1-14 0m12.22-1.75a7.41 7.41 0 1 0-10.48 0 7.42 7.42 0 0 0 10.48 0"
    />
    <path
      fill="#60D15D"
      d="m27.279 24.76-2.617 2.616 6.986 6.986 2.617-2.616z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m24.816 29.744.707-.708 4.127 4.127 2.246-2.247.707.707-2.953 2.954z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKredietcheck);

export default ForwardRef;
